// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_search_sfx_home_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Dive into our amazing library of royalty free sound effects. We have high-quality, exclusive, realistic sound effects that are easy to filter by categories or tags. You can quickly find what you are looking for and enhance your project!`
};

const de_search_sfx_home_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Entdecken Sie unsere atemberaubende Bibliothek aus GEMAfreien Soundeffekten. Wir haben hochwertige, exklusive, realistische Soundeffekte, die einfach nach Kategorien oder Tags zu filtern sind. Bereichern Sie Ihr Videoprojekt und finden finden sie blitzschnell, wonach Sie suchen.`
};

const es_search_sfx_home_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Sumérgete en nuestra increíble biblioteca de efectos de sonido libres de regalías. Tenemos efectos de sonido realistas, exclusivos y de alta calidad que son fáciles de filtrar por categorías o etiquetas. ¡Puedes encontrar rápidamente lo que estás buscando y mejorar tu proyecto!`
};

const pt_br_search_sfx_home_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Mergulhe em nossa incrível biblioteca de efeitos sonoros isentos de royalties. Temos efeitos sonoros realistas, exclusivos e de alta qualidade, fáceis de filtrar por categorias ou tags. Você pode encontrar rapidamente o que procura e aprimorar seu projeto!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "pt-br" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const search_sfx_home_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_sfx_home_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_sfx_home_subtitle", locale)
	if (locale === "en") return en_search_sfx_home_subtitle(inputs)
	if (locale === "de") return de_search_sfx_home_subtitle(inputs)
	if (locale === "es") return es_search_sfx_home_subtitle(inputs)
	return pt_br_search_sfx_home_subtitle(inputs)
};
export { search_sfx_home_subtitle as "search.sfx-home-subtitle" }